import moment from 'moment'

export const isPastMonth = (timeSheetDate: moment.Moment): boolean => {
  const currentMonth = moment().month()
  const timeSheetMonth = timeSheetDate.month()
  const beforeMonth = timeSheetDate.isBefore(moment(), 'month')
  const isNotCurrentMonth = currentMonth !== timeSheetMonth
  return beforeMonth && isNotCurrentMonth
}

export const isPastWeek = (timeSheetDate: moment.Moment): boolean => {
  const currentWeek = moment().week()
  const timeSheetWeek = timeSheetDate.week()
  const beforeWeek = timeSheetDate.isBefore(moment(), 'week')
  const isNotCurrentWeek = currentWeek !== timeSheetWeek
  return beforeWeek && isNotCurrentWeek
}

export const isPastDate = (timeSheetDate: moment.Moment): boolean => {
  return timeSheetDate.isBefore(moment(), 'day')
}
